import { commonCatalog } from "./features/zh/common";

export const common = commonCatalog;
